import {
  BriefcaseBusiness,
  FileCheck2,
  GraduationCap,
  Plane,
  UserRoundPlus,
  UsersRound
} from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { servicesProvided } from "../../data/homeData";

const iconMap = {
  student: GraduationCap,
  work: BriefcaseBusiness,
  tourist: Plane,
  dependent: UsersRound,
  visitor: UserRoundPlus,
  business: FileCheck2
};

function ServicesSection() {
  return (
    <MotionSection id="services" className="relative py-20 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Services Provided"
          title="Visa Services We Support"
          description="Beyond study pathways, we also assist with commonly requested visa categories through clear documentation guidance and practical process support."
        />

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {servicesProvided.map((service) => {
            const Icon = iconMap[service.icon] || FileCheck2;

            return (
              <article
                key={service.title}
                className="group rounded-2xl border border-midnight-navy/12 bg-white p-6 shadow-soft transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-royal-blue/20 bg-royal-blue/10 text-royal-blue">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </div>
                <h3 className="mt-4 text-lg font-bold text-midnight-navy">{service.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-text/80">{service.summary}</p>
              </article>
            );
          })}
        </div>
      </div>
    </MotionSection>
  );
}

export default ServicesSection;
